import { Outlet } from "react-router-dom";
import { ProtectedRoute } from "./_components";

export function ProtectedPageContainer() {
  return (
    // TODO: Missing anything with this style? Without margin, it appears behind Header.
    <div style={{ marginTop: "40px" }}>
      <ProtectedRoute>
        <Outlet />
      </ProtectedRoute>
    </div>
  );
}
